import { Navigate } from "react-router-dom";

//login
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";

import AppSetting from "pages/Setting/AppSetting";
import Edit from "pages/Edit";
import OperatorList from "pages/Operator/Operator";
import ApplicationManagement from "pages/ApplicationManagement";
import PreRegisterList from "pages/PreRegister";
import JobSeekerList from "pages/User/JobSeekerList";
import RecruiterList from "pages/User/RecruiterList";
import JobPostManagement from "pages/JobPost";
import PlanManagement from "pages/PlanManagement";
import UserPlanPurchaseList from "pages/UserPlanPurchase";
import ManualPush from "pages/PushNotification/ManualPush";
import PushLog from "pages/PushNotification/PushLog";
import ResumeViewLogList from "pages/ResumeViewLog";
import NoticeManagement from "pages/NoticeManagement";
import JobSeekerVirtual from "pages/User/JobSeekerVirtual";
import AIContentApprovalList from "pages/ContentManagement/AIContentApproval";
import ContentList from "pages/ContentManagement/Content";
import AgencyList from "pages/Agency";
import VOCReasons from "pages/VOC/VOCReason";
import VOCList from "pages/VOC/VOCList";
import RecruiterVirtualList from "pages/User/RecruiterVirtual";
import AdultVerifyLogList from "pages/AdultVerifyLog";
import InquiryList from "pages/Inquiry";
import CommentList from "pages/CommentManagement/index";
import TalentManagement from "pages/TalentManagement";
import AISetting from "pages/Setting/AISetting";
import SectionManagement from "pages/SectionManagement";
import EventLogList from "pages/EventLog";
import BannerPosition from "pages/BannerPosition";
import BannerManagement from "pages/BannerManagement";
import ContentTypeList from "pages/ContentManagement/ContentType";
import AIContentTBEDList from "pages/ContentManagement/AIContentTBEDList";
import PopupManagerPro from "pages/PopupManagerPro";

const ROUTES = {
  LOGIN: "/login",
  LOGOUT: "/logout",

  HOME: "/",

  DASHBOARD: "/dashboard",
  PROFILE: "/profile",
  PROFILE_SETTING: "/pages-profile-settings",

  LOGIN_HISTORY: "/user/login_history",
  USER_FEEDBACK: "/user/user_feedback",

  PRE_REGISTER: "/pre-register",

  USER_RECRUITER: "/user-management/recruiter",
  USER_RECRUITER_VIRTUAL: "/user-management/recruiter-virtual",
  USER_JOB_SEEKER: "/user-management/job-seeker",
  USER_JOB_SEEKER_VIRTUAL: "/user-management/job-seeker-virtual",

  JOB_POST_MANAGEMENT: "/job-post/job-posts",
  PLAN_MANAGEMENT: "/job-post/plans",
  SECTION_MANAGEMENT: "/job-post/sections",
  USER_PLAN_PURCHASE_LIST: "/job-post/payment-history",
  BANNER_POSITON: "/job-post/banner-position",

  AGENCY_LIST_MANAGEMENT: "/agency-management",

  APPLICATION_MANAGEMENT: "/application/applications",
  TALENT_MANAGEMENT: "/application/talents",

  CONTENT_MANAGEMENT: "/content/community",
  AI_CONTENT_APPROVAL: "/content/community-ai",
  AI_CONTENT_TBED: "/content/community-ai-tbed",
  CONTENT_TYPE: "/content/content-type",
  COMMENT_MANAGEMENT: "/content/comments",

  POPUP_LIST_MANAGEMENT: "/popup-management",

  NOTICE_MANAGEMENT: "/operator/notices",
  INQUIRY_LIST: "/operator/inquiries",
  VOC_REASON: "/operator/voc-reason",
  VOC_LIST: "/operator/voc-list/",

  PUSH_NOTIFICATION_PUSH_LOG: "/push-notification/push-log",
  PUSH_NOTIFICATION_MANUAL_PUSH: "/push-notification/manual-push",

  RESUME_VIEW_LOG: "/logs/resume-view-log",
  ADULT_VERIFY_LOG: "/logs/adult-verify-log",
  EVENT_LOG: "/logs/event-log",

  OPERATOR_LIST: "/operator/list",
  OPERATOR_ROLE: "/operator/role",
  OPERATOR_ACTIVITY_LOG: "/operator/activity-logs",
  OPERATOR_PROFILE: "/operator/profile",

  SETTING: "/setting",
  APP_SETTING: "/setting/app-setting",
  AI_SETTING: "/setting/ai-setting",
  EDIT: "/edit",


  BANNER_MANAGEMENT: "/banner-management"
};

const ROUTE_NAMES = [
  {
    link: ROUTES.LOGIN,
    name: "Login",
  },
  {
    link: ROUTES.PRE_REGISTER,
    name: "Pre-Register",
  },
  {
    link: ROUTES.USER_JOB_SEEKER,
    name: "Job Seeker",
  },
  {
    link: ROUTES.USER_RECRUITER,
    name: "Recruiter",
  },
  {
    link: ROUTES.OPERATOR_LIST,
    name: "Administrator Management",
  },
  {
    link: ROUTES.JOB_POST_MANAGEMENT,
    name: "Job Post Management",
  },
  {
    link: ROUTES.TALENT_MANAGEMENT,
    name: "Talent Management",
  },
  {
    link: ROUTES.PLAN_MANAGEMENT,
    name: "Plan Management",
  },
  {
    link: ROUTES.USER_PLAN_PURCHASE_LIST,
    name: "User Plan Purchase",
  },
  {
    link: ROUTES.CONTENT_MANAGEMENT,
    name: "Content Management",
  },
  {
    link: ROUTES.PUSH_NOTIFICATION_PUSH_LOG,
    name: "Push Log",
  },
  {
    link: ROUTES.PUSH_NOTIFICATION_MANUAL_PUSH,
    name: "Send Push (Manual)",
  },
];

const authProtectedRoutes = [
  // Pre Register
  { path: ROUTES.PRE_REGISTER, component: <PreRegisterList /> },

  { path: ROUTES.USER_RECRUITER, component: <RecruiterList /> },
  { path: ROUTES.USER_RECRUITER_VIRTUAL, component: <RecruiterVirtualList /> },
  { path: ROUTES.USER_JOB_SEEKER, component: <JobSeekerList /> },
  { path: ROUTES.USER_JOB_SEEKER_VIRTUAL, component: <JobSeekerVirtual /> },

  { path: ROUTES.JOB_POST_MANAGEMENT, component: <JobPostManagement /> },

  { path: ROUTES.TALENT_MANAGEMENT, component: <TalentManagement /> },

  { path: ROUTES.AGENCY_LIST_MANAGEMENT, component: <AgencyList /> },

  { path: ROUTES.PLAN_MANAGEMENT, component: <PlanManagement /> },

  { path: ROUTES.USER_PLAN_PURCHASE_LIST, component: <UserPlanPurchaseList /> },

  { path: ROUTES.APPLICATION_MANAGEMENT, component: <ApplicationManagement /> },

  { path: ROUTES.NOTICE_MANAGEMENT, component: <NoticeManagement /> },

  { path: ROUTES.INQUIRY_LIST, component: <InquiryList /> },

  { path: ROUTES.COMMENT_MANAGEMENT, component: <CommentList /> },
  { path: ROUTES.POPUP_LIST_MANAGEMENT, component: <PopupManagerPro /> },

  { path: ROUTES.VOC_REASON, component: <VOCReasons /> },
  { path: ROUTES.VOC_LIST, component: <VOCList /> },

  { path: ROUTES.CONTENT_MANAGEMENT, component: <ContentList /> },
  { path: ROUTES.AI_CONTENT_APPROVAL, component: <AIContentApprovalList /> },
  { path: ROUTES.AI_CONTENT_TBED, component: <AIContentTBEDList /> },

  { path: ROUTES.CONTENT_TYPE, component: <ContentTypeList /> },

  { path: ROUTES.PUSH_NOTIFICATION_PUSH_LOG, component: <PushLog /> },
  { path: ROUTES.PUSH_NOTIFICATION_MANUAL_PUSH, component: <ManualPush /> },

  { path: ROUTES.RESUME_VIEW_LOG, component: <ResumeViewLogList /> },
  { path: ROUTES.ADULT_VERIFY_LOG, component: <AdultVerifyLogList /> },
  { path: ROUTES.EVENT_LOG, component: <EventLogList /> },

  { path: ROUTES.OPERATOR_LIST, component: <OperatorList /> },

  { path: ROUTES.SETTING, component: <></> },

  { path: ROUTES.APP_SETTING, component: <AppSetting /> },
  { path: ROUTES.AI_SETTING, component: <AISetting /> },

  { path: ROUTES.EDIT, component: <Edit /> },

  { path: ROUTES.SECTION_MANAGEMENT, component: <SectionManagement /> },
  { path: ROUTES.BANNER_POSITON, component: <BannerPosition /> },
  { path: ROUTES.BANNER_MANAGEMENT, component: <BannerManagement /> },

  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to={ROUTES.PRE_REGISTER} />,
  },
  { path: "*", component: <Navigate to={ROUTES.PRE_REGISTER} /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },
];

export { authProtectedRoutes, publicRoutes, ROUTE_NAMES, ROUTES };
